module.exports = __webpack_public_path__ + "img/204318-14-9111.59545e91.png";